import React, { Component } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import moment from 'moment';
import DateRangePicker from 'react-bootstrap-daterangepicker';

import throttle from '../../../../util/throttle';

import { handleError, saveConfig, updateTrials, updateCompletedItems, updateStartDate } from '../../FilterActions';

// Import Style
import './MonteCarloDeliveryControls.scss';

class MonteCarloDeliveryControls extends Component {
  constructor(props) {
    super(props);

    this.state = {};

    this.saveChanges = throttle(this._saveChanges, 1000, this);
  }

  componentDidMount() {
    this.updateState();
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.trials !== this.props.trials ||
      prevProps.completedItems !== this.props.completedItems ||
      prevProps.date !== this.props.date
    ) {
      this.updateState();
    }
  }

  updateState() {
    this.setState({
      trials: this.props.trials,
      completedItems: this.props.completedItems,
      date: moment(this.props.date),
    });
  }

  _saveChanges = (name, value) => {
    const isNumber = !!value && _.isNumber(+value);
    let save = false;

    switch (name) {
      case 'date': {
        this.props.updateStartDate(moment(value));
        save = true;
        break;
      }
      case 'completedItems': {
        if (value < 0) {
          this.props.handleError(`Completed Items value should be a positive number`);
          return false;
        }
        if (value > 1000) {
          this.props.handleError(`Completed Items value should be less than 1000`);
          return false;
        }
        if (isNumber) {
          save = true;
          this.props.updateCompletedItems(value);
        }
        break;
      }
      case 'trials': {
        if (value < 0) {
          this.props.handleError(`Trials value should be a positive number`);
          return false;
        }
        if (value > 1000000) {
          this.props.handleError(`Trials value should be less than 1,000,000`);
          return false;
        }
        if (isNumber) {
          save = true;
          this.props.updateTrials(value);
        }
        break;
      }
    }

    if (save) {
      this.props.saveConfig();
    }
  };

  handleChange = (e) => {
    const value = e.target.value;
    this.setState({
      [e.target.name]: value,
    });
    this.saveChanges(e.target.name, e.target.value);
  };

  render() {
    return (
      <div className='delivery-control'>
        <DateRangePicker
          locale={{ format: this.props.dateFormat }}
          startDate={this.state.date}
          singleDatePicker
          onApply={(e, picker) =>
            this.handleChange({
              target: { name: 'date', value: picker.startDate },
            })
          }
        >
          <div className='date-range-picker'>
            <label>Start Date</label>
            <div className='form-control'>{moment(this.state.date).format(this.props.dateFormat)}</div>
          </div>
        </DateRangePicker>
        
        <div>
          <label htmlFor="completedItems">Items to complete</label>
          <input
            name="completedItems"
            type="number"
            id="completedItems"
            placeholder="Completed Items"
            className='form-control'
            value={this.state.completedItems}
            onChange={this.handleChange}
          />
        </div>

        <div>
          <label htmlFor="trials">Trials</label>
          <input
            name="trials"
            type="number"
            id="trials"
            placeholder="Trials"
            className='form-control'
            value={this.state.trials}
            onChange={this.handleChange}
          />
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    handleError: (err) => dispatch(handleError(err, { log: false })),
    saveConfig: () => dispatch(saveConfig()),
    updateTrials: (val) => dispatch(updateTrials(val, 'mc')),
    updateCompletedItems: (val) => dispatch(updateCompletedItems(val, 'mc')),
    updateStartDate: (val) => dispatch(updateStartDate(val, 'mc')),
  };
};

const mapStateToProps = (state) => {
  return {
    trials: state.filters.mc.trials,
    completedItems: state.filters.mc.completedItems,
    date: state.filters.mc.date,
    dateFormat: state.filters.dateFormat,
  };
};

const connected = connect(mapStateToProps, mapDispatchToProps)(MonteCarloDeliveryControls);
export { connected as MonteCarloDeliveryControls };
